export function languageNativeName(code: string): string {
    const names: Record<string, string> = {
        en: 'English',
        es: 'Español',
        fr: 'Français',
        de: 'Deutsch',
        it: 'Italiano',
        pt: 'Português',
        zh: '中文',
        ja: '日本語',
        ko: '한국어',
        ar: 'العربية',
        ru: 'Русский',
        uk: 'Українська',
        pl: 'Polski',
        nl: 'Nederlands',
        tr: 'Türkçe',
        hi: 'हिन्दी',
        th: 'ไทย',
        vi: 'Tiếng Việt',
        id: 'Bahasa Indonesia',
        sv: 'Svenska',
        da: 'Dansk',
        no: 'Norsk',
        fi: 'Suomi',
        el: 'Ελληνικά',
        he: 'עברית',
        cs: 'Čeština',
        ro: 'Română',
        hu: 'Magyar',
    };
    return names[code] ?? code.toUpperCase();
}

export function localeStorageKey(menuId: number): string {
    return `tlg.locale.${menuId}`;
}

export function resolveInitialLocale(menuId: number, supported: string[]): string {
    try {
        const stored = localStorage.getItem(localeStorageKey(menuId));
        if (stored === 'en' || (stored && supported.includes(stored))) return stored;
    } catch {
        // private mode
    }
    const browser = navigator.language?.slice(0, 2).toLowerCase();
    if (browser && supported.includes(browser)) return browser;
    return 'en';
}
